import { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Relatorio.css";
import { FaFileAlt } from "react-icons/fa";

const SenhasLimpasDono = () => {
  const [eventos, setEventos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState("");
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("");
  const [senhaInicial, setSenhaInicial] = useState("");
  const [senhaFinal, setSenhaFinal] = useState("");
  const [loading, setLoading] = useState(false);

  // Carregar todos os eventos (admin)
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        setLoading(true);
        const response = await axios.get("https://api.ticketdovaqueiro.com/api/events/dono", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setEventos(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Erro ao buscar eventos:", error);
        setLoading(false);
      }
    };
    fetchEventos();
  }, []);

  // Carregar categorias do evento
  useEffect(() => {
    const fetchCategorias = async () => {
      if (eventoSelecionado) {
        try {
          setLoading(true);
          const response = await axios.get(
            `https://api.ticketdovaqueiro.com/api/events/${eventoSelecionado}/categorias`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          setCategorias(response.data);
          setLoading(false);
        } catch (error) {
          console.error("Erro ao buscar categorias:", error);
          setLoading(false);
        }
      }
    };
    fetchCategorias();
  }, [eventoSelecionado]);

  const handleGerarSenhasPDF = () => {
    if (!eventoSelecionado || !categoriaSelecionada || !senhaInicial || !senhaFinal) {
      alert("Preencha todos os campos!");
      return;
    }

    window.open(
      `https://api.ticketdovaqueiro.com/api/relatorios/gerar-pdf-senhas-limpas?eventoId=${eventoSelecionado}&categoria=${categoriaSelecionada}&senhaInicial=${senhaInicial}&senhaFinal=${senhaFinal}`,
      "_blank"
    );
  };

  return (
    <div className="relatorio-container">
      <h2 className="relatorio-titulo">📄 Gerar Senhas Limpas</h2>

      <div className="form-group">
        <label>Evento</label>
        <select value={eventoSelecionado} onChange={(e) => setEventoSelecionado(e.target.value)} disabled={loading}>
          <option value="">Selecione um evento</option>
          {eventos.map((evento) => (
            <option key={evento._id} value={evento._id}>
              {evento.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Categoria</label>
        <select
          value={categoriaSelecionada}
          onChange={(e) => setCategoriaSelecionada(e.target.value)}
          disabled={!categorias.length || loading}
        >
          <option value="">Selecione uma categoria</option>
          {categorias.map((categoria) => (
            <option key={categoria._id} value={categoria.nome}>
              {categoria.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Senha Inicial</label>
        <input
          type="number"
          value={senhaInicial}
          onChange={(e) => setSenhaInicial(e.target.value)}
          placeholder="Ex: 1"
        />
      </div>

      <div className="form-group">
        <label>Senha Final</label>
        <input
          type="number"
          value={senhaFinal}
          onChange={(e) => setSenhaFinal(e.target.value)}
          placeholder="Ex: 50"
        />
      </div>

      <button
        className="botao-locutorjuiz"
        onClick={handleGerarSenhasPDF}
        disabled={!eventoSelecionado || !categoriaSelecionada || loading}
      >
        <FaFileAlt size={18} />
        Gerar PDF de Senhas Limpas
      </button>
    </div>
  );
};

export default SenhasLimpasDono;
